import React, { useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import { Link, useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import Swal from 'sweetalert2';

import getValidationErros from '~/utils/getValidationsErrors';

import { Container } from './styles';
import Input from '~/components/Input';

import Logo from '~/assets/logos/Logo';
import signinBackground from '~/assets/banners/signin-background.svg';

const ChangePassword: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const history = useHistory();

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          password: Yup.string().required('A senha é obrigatória'),
          confirmPassword: Yup.string().oneOf(
            [Yup.ref('password'), null],
            'As senhas devem ser iguais'
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });
        history.push(`${process.env.PUBLIC_URL}/fornecedor/login`);
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro tente novamente, por favor');
        }
      }
    },
    [history]
  );

  return (
    <Container>
      <div className="container pt-5 pb-4">
        <div className="row justify-content-between align-items-center">
          <div className="col-lg-5 pt-5">
            <Link
              to={`${process.env.PUBLIC_URL}`}
              className="d-flex d-lg-none align-items-end mb-5"
            >
              <Logo color="#202020" className="me-2" />
              <span className="text-start d-block fs-6 fs-lg-4 fw-light mb-0 logo-name">
                Prime Odontologia
              </span>
            </Link>
            <div className="w-100">
              <h1>Recuperar senha</h1>
              <p className="h5 fw-light">Informe sua nova senha abaixo</p>
            </div>
            <Form ref={formRef} onSubmit={handleSubmit} className="mt-5">
              <label className="d-block w-100 mb-3">
                <span className="fw-medium mb-2 d-block">Senha</span>
                <Input
                  type="password"
                  name="password"
                  placeholder="Insira sua nova senha"
                />
              </label>
              <label className="d-block w-100 mb-3">
                <span className="fw-medium mb-2 d-block">Confirmar Senha</span>
                <Input
                  type="password"
                  name="confirmPassword"
                  placeholder="Repita sua nova senha"
                />
              </label>
              <button
                type="submit"
                className="btn btn-primary rounded-pill w-100 py-2 mt-5"
              >
                Continuar
              </button>
            </Form>
          </div>
        </div>
      </div>
      <img src={signinBackground} alt="" className="banner d-none d-lg-block" />
    </Container>
  );
};

export default ChangePassword;
